import { Grid } from "semantic-ui-react";

const SubnetsDivider = () => (
  <Grid.Column
    className="separator separator--simple padding-top-00 margin-bottom-00"
    width={16}
  ></Grid.Column>
);

export default SubnetsDivider;
